module.exports = __webpack_public_path__ + "img/g7.db4716a5.png";